document.addEventListener("DOMContentLoaded", () => {
  const burger = document.querySelector('[data-burger]');
  const nav = document.querySelector('[data-nav]');
  const body = document.body;
  const navItems = nav ? nav.querySelectorAll('a') : [];

  if (burger && nav) {
    burger.addEventListener('click', (event) => {
      event.preventDefault();
      burger.blur();
      body.classList.toggle('dis-scroll');
      burger.classList.toggle('burger--active');
      nav.classList.toggle('nav--visible');
    });
  }

  if (navItems.length > 0 && burger && nav) {
    navItems.forEach(el => {
      el.addEventListener('click', () => {
        body.classList.remove('dis-scroll');
        burger.classList.remove('burger--active');
        nav.classList.remove('nav--visible');
      });
    });
  }

});
